import StringMask from 'string-mask'

export const masksByLength = {
    13: "00000 0000 0000",
    14: "0000 000000 0000",
    15: "00000000 0000 000",
    16: "0000 0000 0000 0000",
    17: "00000000 00000 0000",
    18: "0000000000 00000 000",
    19: "0000000000 00000 0000"
}

const lengthsById = {
    1: [16, 13],
    8: [14],
    15: [17, 16],
    23: [19, 16],
    44: [19, 16],
    65: [15],
    111: [15],
    113: [16],
    99: [18, 17, 16],
    103: [18],
    106: [19, 18, 17, 16, 15],
    122: [18],
    126: [18],    
    117: [18, 16]
}

const getLengthsById = (paymentMethod) => {

    const defaultLengths = [16]
    let lengths = lengthsById[paymentMethod]
    if (!lengths) lengths = defaultLengths

    return lengths
}

// con 0 en el formato le decimos que puede ser un valor parcial
const formatCardNumber = (bin, restOfCC, format) => {
    const formattedBin = StringMask.apply(bin, format).trim()
    const formattedFullCC = StringMask.apply(`${bin}${restOfCC}`, format).trim()
    const formattedRestOfCC = formattedFullCC.substring(formattedBin.length)

    return {
        bin: formattedBin,
        restOfCC: formattedRestOfCC
    }
}

const getMask = (ccNumber, paymentMethod) => {
    const lengths = getLengthsById(paymentMethod)
    let i = 0
    while (ccNumber.length <= lengths[i] && i < lengths.length) i++

    let ccLength = lengths[i - 1]
    if (!ccLength) ccLength = lengths[0]

    return masksByLength[ccLength]
}

const cardLogos = {
    1: "visa",
    8: "diners",
    15: "master",
    65: "american-express",
    23: "tarjeta-shopping",
    24: "tarjeta-naranja",
    25: "pago-facil",
    26: "rapi-pago",
    27: "cabal",
    29: "italcred",
    30: "argencard",
    31: "visa-debito",
    34: "coopeplus",
    37: "nexo",
    38: "credimas",
    39: "tarjeta-nevada",
    41: "pago-mis-cuentas",
    42: "nativa",
    43: "tarjeta-cencosud",
    44: "tarjeta-carrefour",
    45: "tarjeta-pyme-nacion",
    50: "bbps",
    51: "cobro-express",
    52: "qida",
    54: "grupar",
    55: "patagonia-365",
    56: "tarjeta-club-dia",
    57: "musicred",
    59: "tuya",
    60: "visa",
    61: "tarjeta-la-anonima",
    62: "credi-guia",
    63: "cabal",
    64: "tarjeta-sol",
    66: "mastercard-debito",
    67: "cabal-debito",
    99: "maestro",
    102: "wish-gift",
    103: "favacard",
    104: "master",
    105: "mastercard-debito",
    106: "maestro",
    108: "cabal-debito",
    109: "nativa",
    111: "american-express-prisma",
    113: "sucredito",
    115: "consumax",
    138: "credi-guia-logo2",
    139: "discover-card",
    140: "confiable",
    141: "tarjeta-milenia",
    142: "master-card-prepaga",
    116: "master-card-prepaga",
    114: "visa-prepaga",
    143: "tarjeta-sol",
    144:"patagonia-365",
    145:"tuya-v2",
    117: "favacard"
}

const findPaymentMethodIdByBin = (value, binRanges, sortedPaymentMethods) => {
    const bin = value.substring(0, 6)

    for (let paymentMethodId of sortedPaymentMethods) {
        const paymentMethod = binRanges[paymentMethodId]
        if (paymentMethod && isBinBetween(paymentMethod.ranges, bin)) {
            return paymentMethodId
        }
    }
    return null
}

const validateBin = (value, paymentMethodId, binRanges) => {
    const paymentMethod = binRanges[paymentMethodId]
    if (!paymentMethod) return false

    const bin = value.substring(0, 6)
    const binLength = bin.length
    if (binLength === 0) return false
    return isBinBetween(paymentMethod.ranges, bin)
}

const isBinBetween = (rangos, bin) => {
    return rangos.some(rango => {
        const binLength = bin.length
        const inferior = rango.inferior.substring(0, binLength)
        const superior = rango.superior.substring(0, binLength)
        return inferior <= bin && bin <= superior
    })
}

function validateLuhnAlgorithm(cardNumber) {
    var ca, sum = 0, mul = 0
    var len = cardNumber.length
    while (len--) {
        ca = parseInt(cardNumber.charAt(len), 10) << mul
        sum += ca - (ca > 9) * 9
        mul ^= 1
    }

    return (sum % 10 === 0) && (sum > 0)

}


export {
    cardLogos,
    getLengthsById,
    findPaymentMethodIdByBin,
    formatCardNumber,
    getMask,
    validateBin,
    validateLuhnAlgorithm
}
